
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { RiArrowGoBackFill } from "react-icons/ri";

export function getMonthOptions() {
    const months = [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'
    ];


    return months.map((month, index) => ({
        value: (index + 1).toString().padStart(2, '0'),
        label: month
    }));
}
export function dynamicYears() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const futureYears = currentMonth < 11 ? 0 : 1;

    return Array.from({ length: futureYears + 1 }, (_, index) => currentYear + index);
}

export function dynamicMonths() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    const months = [];

    for (let i = currentMonth; i > 0; i--) {
        const monthIndex = (i - 1) % 12;
        const year = currentYear + Math.floor((i - 1) / 12);
        months.unshift({
            value: `${monthIndex + 1 < 10 ? '0' : ''}${monthIndex + 1}`,
            label: new Date(year, monthIndex).toLocaleDateString('en-US', { month: 'long' })
        });
    }

    return months;
}


export function dynamicYearfrom2018() {
    const currentYear = new Date().getFullYear();
    const startYear = 2018;

    const yearsAscending = Array.from({ length: currentYear - startYear + 1 }, (_, index) => startYear + index);

    return yearsAscending;
}

export function displayYearsDescending() {
    const years = dynamicYearfrom2018();
    return years.reverse();
}


export function getYearsDynamicBasedOnInput(startYear) {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= startYear; year--) {
        years.push(year);
    }
    return years;
}

export function getMonthsDynamicBasedOnInput(year) {
    const months = [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'
    ];
    const currentMonth = new Date().getMonth() + 1;
    const monthLimit = year === new Date().getFullYear().toString() ? currentMonth : 12;
    return months.slice(0, monthLimit).map((month, index) => ({
        value: (index + 1).toString().padStart(2, '0'),
        label: month
    }));
}


//newly added
export const monthNamesArray = [
    { monthValue: '01', monthName: 'January' },
    { monthValue: '02', monthName: 'February' },
    { monthValue: '03', monthName: 'March' },
    { monthValue: '04', monthName: 'April' },
    { monthValue: '05', monthName: 'May' },
    { monthValue: '06', monthName: 'June' },
    { monthValue: '07', monthName: 'July' },
    { monthValue: '08', monthName: 'August' },
    { monthValue: '09', monthName: 'September' },
    { monthValue: '10', monthName: 'October' },
    { monthValue: '11', monthName: 'November' },
    { monthValue: '12', monthName: 'December' }
]

export function openPdfInNewTab(base64) {
    const blob = base64ToBlob(base64);
    const url = URL.createObjectURL(blob);
    const newWindow = window.open('', '_blank');

    // Write an iframe to the new window for reliable rendering
    newWindow.document.write(`
        <iframe width="100%" height="100%" src="${url}" frameborder="0"></iframe>
      `);

    // Optional cleanup when the new tab closes
    newWindow.addEventListener('unload', () => {
        URL.revokeObjectURL(url);
    });
}

function base64ToBlob(base64, contentType = 'application/pdf') {
    const binary = atob(base64);
    const len = binary.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        arr[i] = binary.charCodeAt(i);
    }
    return new Blob([arr], { type: contentType });
}


// utils/timeUtils.js
export const getTokenExpiry = (token) => {
    try {
        const decoded = jwtDecode(token);
        if (!decoded?.exp) return null;
        return decoded.exp * 1000; // Convert to milliseconds
    } catch {
        return null;
    }
};

export const calculateTimeLeft = (expiryTime) => {
    if (!expiryTime) return 0;
    return Math.max(0, expiryTime - Date.now());
};

export const formatTime = (ms) => {
    if (ms <= 0) return '00:00';
    const seconds = Math.floor(ms / 1000) % 60;
    const minutes = Math.floor(ms / (1000 * 60)) % 60;
    const hours = Math.floor(ms / (1000 * 60 * 60));

    if (hours > 0) {
        return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const isTokenValid = (token) => {
    const expiry = getTokenExpiry(token);
    return expiry && expiry > Date.now();
};



const MySwal = withReactContent(Swal);

export const showCustomAlert = () => {
    MySwal.fire({
        html: (

            <div className="text-left">
                <div style={{
                    backgroundColor: '#f8d7da',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    color: '#721c24',
                    border: '1px solid #f5c6cb',
                    fontFamily: 'Segoe UI, sans-serif',
                    fontSize: '15px',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                    lineHeight: '1.6',
                    position: 'relative'
                }}>
                    <strong style={{ fontSize: '16px', display: 'block', marginBottom: '6px' }}>
                        ⚠️  Note
                    </strong>
                    Please enter area values as follows:
                    <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
                        <li><strong>APCHE approved courses</strong>: Enter in <strong>square feet (sq.ft)</strong>.</li>
                        <li><strong>AICTE approved courses</strong>: Enter in <strong>square meters (sq.m)</strong>.</li>
                    </ul>
                </div>
            </div>

        ),
        backdrop: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
            popup: 'swal-xl' // You can define 'swal-xl' in your CSS
        },
        width: '30%', // For size "xl"
        didOpen: () => {
            // Optional: any logic you want after open
        }
    });
};

export default async function SweetalertRedirectToHome(text, icon) {
    Swal.fire({
        text: text,
        icon: icon,
        backdrop: true,
        allowOutsideClick: false,

        allowEscapeKey: false,
        didOpen: () => {
            const swalModal = Swal.getPopup();
            if (swalModal) {
                swalModal.setAttribute("tabindex", "0");
                swalModal.focus();
            }
        },
    }).then((refresh) => {
        if (refresh.isConfirmed) {
            window.location.href = "/";
        }
    })
}

export const BackButton = () => {
    const navigate = useNavigate();

    return (
        <button
            type='button'
            onClick={() => navigate(-1)}
            className='btn btn-primary btn-sm float-end'> Back
        </button>
    );
}